import { useEffect, useState } from 'react';
import { app } from '@microsoft/teams-js';

export function useTeamsThemeMode(forceDarkMode?: boolean) {
  const [prefersDarkMode, setPrefersDarkMode] = useState(forceDarkMode);

  useEffect(() => {
    app.getContext().then((context) => {
      switch (context.app.theme) {
        case 'default':
          setPrefersDarkMode(false);
          break;
        case 'dark':
        case 'contrast':
          setPrefersDarkMode(true);
          break;
        default:
          setPrefersDarkMode(false);
      }
    });
  }, []);

  return { prefersDarkMode };
}
